import { render } from "./AppMain.vue?vue&type=template&id=0e3f522c"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=0e3f522c&lang=css"

import exportComponent from "/home/jenkinsx/workspace/build-dc-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__